import Cookies from 'js-cookie';
import { TOKEN_NAME } from '../constants';

// The JWT's own expiry (`exp`, seconds since epoch), or null when unreadable.
function tokenExpiry(token) {
  try {
    const part = (token || '').split('.')[1];
    if (!part) return null;
    const padded = part + '='.repeat((4 - (part.length % 4)) % 4);
    const exp = JSON.parse(atob(padded.replace(/-/g, '+').replace(/_/g, '/'))).exp;
    return Number.isFinite(exp) ? new Date(exp * 1000) : null;
  } catch {
    return null;
  }
}

// Store the session token in a cookie that lives as long as the token itself
// (JWT_EXPIRY, 24 h in prod). Without `expires` it was a browser-session
// cookie: closing the browser logged the operators out (Sofia, Oct 27 2026).
export function setSessionCookie(token) {
  const expires = tokenExpiry(token);
  Cookies.set(TOKEN_NAME, token, {
    ...(expires ? { expires } : {}),
    sameSite: 'lax',
    secure: window.location.protocol === 'https:',
  });
}
